import { fetchBilling } from "./account.service";

export const accountService = { fetchBilling };
